import React, { useEffect, useState, useRef } from 'react';
import { FaPlay, FaPause, FaVolumeUp} from 'react-icons/fa';

const CustomeVideoControler = ({videoRef}) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [volume, setVolume] = useState(1);
  const [recordingTime, setRecordingTime] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setRecordingTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying]);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleVolumeChange = (event) => {
    const newVolume = event.target.value;
    setVolume(newVolume);
    videoRef.current.volume = newVolume;
  };

  const handleFullscreen = () => {
    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen();
    } else if (videoRef.current.mozRequestFullScreen) {
      videoRef.current.mozRequestFullScreen();
    } else if (videoRef.current.webkitRequestFullscreen) {
      videoRef.current.webkitRequestFullscreen();
    } else if (videoRef.current.msRequestFullscreen) {
      videoRef.current.msRequestFullscreen();
    }
  };
  

  return (
    <div className="custom-video-controls flex items-center justify-between p-2 bg-gray-900 text-white">
      <div className='flex items-center gap-2'>
        <button onClick={handlePlayPause} className="control-button">
          {isPlaying ? <FaPause /> : <FaPlay />}
        </button>
        <span className="mx-2">{new Date(recordingTime * 1000).toISOString().substr(11, 8)}</span>
      </div>
      
      <div className='flex items-center gap-2'>
      <div className="flex items-center">
        <FaVolumeUp />
        <input
          type="range"
          min="0"
          max="1"
          step="0.1"
          value={volume}
          onChange={handleVolumeChange}
          className="mx-2"
        />
      </div>
      
      </div>
    </div>
  );
};

export default CustomeVideoControler;